import { BRAND } from "@/lib/content";
import { brl, fmtDay } from "@/lib/api";

export function osWhatsappText(os, link) {
  const c = os.cliente, v = os.veiculo, val = os.valores;
  const flags = [v.origem, v.blindado && "Blindado", v.eletrico && "Elétrico", v.hibrido && "Híbrido"].filter(Boolean).join(" · ");
  const lines = [
    BRAND.waMensagem, "",
    `*ORDEM DE SERVIÇO ${os.numero}*`, "",
    "*Dados do cliente*",
    `Nome: ${c.nome}`, `Telefone: ${c.telefone}`,
    c.whatsapp ? `WhatsApp: ${c.whatsapp}` : null,
    c.email ? `E-mail: ${c.email}` : null,
    `Endereço: ${c.endereco} — ${c.cidade}/${c.estado}${c.cep ? ` — CEP ${c.cep}` : ""}`, "",
    "*Dados do veículo*",
    `${v.marca} ${v.modelo} ${v.versao || ""} ${v.ano || ""}`.replace(/\s+/g, " ").trim(),
    `Placa: ${v.placa || "—"} · Cor: ${v.cor || "—"} · Km: ${v.quilometragem || "—"}`,
    flags, "",
    "*Serviços escolhidos*",
    ...os.linhas.map((l) => `${l.code}. ${l.nome} — ${brl(l.preco)}`), "",
    "*Descrição operacional*",
    ...os.descricao_operacional.map((d, i) => `${i + 1}) ${d}`), "",
    `*Deslocamento:* ${val.deslocamento == null ? "A definir pelo prestador" : brl(val.deslocamento)}`,
    `*Valor total:* ${brl(val.total)}${val.precificado ? "" : " (parcial — deslocamento/preços a definir pelo prestador)"}`,
    val.sinal_percent ? `*Sinal (${val.sinal_percent}%):* ${brl(val.sinal)} · Saldo: a combinar` : null,
    `*Forma de pagamento:* ${os.forma_pagamento}`,
    `*Data pretendida:* ${fmtDay(os.data_pretendida)}`,
    `*Local:* ${os.local_atendimento || "—"}`,
    `*Observações:* ${os.observacoes || "—"}`,
    link ? `\nOrdem de serviço: ${link}` : null,
  ];
  return lines.filter((x) => x !== null && x !== false).join("\n");
}

export function drWhatsappText(dr) {
  const pd = dr.pre_diagnostico || {};
  return [
    "Olá, Nillo Ruídos. Solicito avaliação do Dr. Ruídos e agendamento de inspeção do veículo.", "",
    `*Protocolo:* ${dr.protocolo}`,
    `*Cliente:* ${dr.nome} — ${dr.telefone}`,
    `*Cidade:* ${dr.cidade}${dr.estado ? `/${dr.estado}` : ""}`,
    `*Veículo:* ${dr.veiculo}`,
    `*Descrição do ruído:* ${dr.descricao}`,
    `*Quando ocorre:* ${dr.quando_ocorre || "—"}`,
    `*Velocidade aproximada:* ${dr.velocidade || "—"}`,
    `*Piso:* ${dr.piso || "—"}`,
    `*Condições específicas:* ${dr.condicoes || "—"}`,
    pd.problemas_relacionados?.length ? `*Problemas relacionados:* ${pd.problemas_relacionados.join("; ")}` : null,
    `*Arquivos enviados:* ${dr.arquivos?.length || 0}`,
    `*Inspeção desejada:* ${fmtDay(dr.data_inspecao)} ${dr.periodo || ""} — ${dr.local_inspecao || "local a combinar"}`,
  ].filter((x) => x !== null).join("\n");
}
